import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import { useEffect, useState } from "react";
import RouteGenerator from "./routes/RouteGenerator";
import { HiBars3 } from "react-icons/hi2";
/*  This Component for displaying Header 
*  Routes file has been used to difining the links of pages
 | khaled Mofeed */

function Header() {
  const [headerClassName, setHeaderClassName] = useState("");
  /*  This function used to handle the scroll screen and fixing the header in the top position 
  | khaled Mofeed */
  const handleScroll = (headerClassName) => {
    const PAGE_Y_OFFSET = 100;
    if (
      headerClassName !== "menuscroll" &&
      window.pageYOffset >= PAGE_Y_OFFSET
    ) {
      setHeaderClassName("menuscroll");
    } else if (
      headerClassName === "menuscroll" &&
      window.pageYOffset < PAGE_Y_OFFSET
    ) {
      setHeaderClassName("");
    }
  };
  /*  IMPORTANT, This will cause react to update depending on change of this value
  | khaled Mofeed  */
  useEffect(() => {
    window.onscroll = () => handleScroll(headerClassName);
  }, [headerClassName]);

  return (
    <Row className={`justify-content-center header-top ${headerClassName}`}>
      <Col md={12} lg={10}>
        <Navbar expand="lg" sticky="top">
          <Navbar.Brand>
            <Link to="/">
              <img
                id="id_logo"
                src="/img/logo.svg"
                alt="logo"
                className="logo d-none d-lg-block"
              />
              <img
                id="id_logoMobile"
                src="/img/logo.svg"
                alt="logo"
                className="logo-mobile d-block d-lg-none"
              />
            </Link>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" id="id_ToggleBtn">
            <HiBars3 />
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="">
              {/*  This element for  static menu in header | khaled Mofeed*/}
              <RouteGenerator excludeIds={["Contact"]} />
              <a
                href="/#ContactUs"
                className="custom-primary d-none d-lg-block btn btn-primary"
                id="id_DiscoverBtn"
              >
                Contact Us
              </a>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Col>
    </Row>
  );
}

export default Header;
